const cartReducer = (state = [], action) => {
    switch (action.type) {
        case 'ADD_TO_CART':
            if (state.find((item) => item.id === action.data.id)) {
                return state
            }
            return [...state, action.data]
        case 'REMOVE_FROM_CART':
            return state.filter((item) => item.id !== action.data)
        case 'CLEAR_CART':
            return []
        default:
            return state
    }
}

export const addToCart = (course) => {
    return {
        type: 'ADD_TO_CART',
        data: {
            id: course._id || course.id,
            name: course.name,
            image: course.image,
            price: course.price || 0, // Courses are free but maybe we want a price later
            type: course.type || 'Certificate'
        }
    }
}

export const removeFromCart = (id) => {
    return {
        type: 'REMOVE_FROM_CART',
        data: id
    }
}

export const clearCart = () => {
    return {
        type: 'CLEAR_CART'
    }
}

export default cartReducer
